import PropTypes from "prop-types";
import "./PrivacyPolicy.css";
import Header from "../common/Header";
import Footer from "../common/Footer";
import PageWrapper from "../common/PageWrapper";

const PrivacyPolicy = ({ menuState }) => {
  const { isMenuOpen, setIsMenuOpen, onMenuToggle } = menuState;

  return (
    <div className="privacy-policy-wrapper">
      <Header
        isMenuOpen={isMenuOpen}
        setIsMenuOpen={setIsMenuOpen}
        onMenuToggle={onMenuToggle}
      />

      <PageWrapper isMenuOpen={isMenuOpen}>
        <main className="privacy-policy-content">
          <section className="privacy-policy-introduction">
            <h1>Politique de confidentialité</h1>
            <p>
              Afin que vous puissiez utiliser en toute confiance le site <strong>vehidoc.fr</strong> (le « Site ») et les services liés proposés par la société MFLJ (ci-après « MFLJ » telle qu&apos;identifiée dans la section 3), la présente politique de confidentialité vise à décrire de manière transparente quelles données sont traitées par MFLJ, comment et pourquoi.
            </p>
          </section>

          {/* Section 1: Type de données collectées */}
          <section className="privacy-policy-section">
            <h2>1. Type de données collectées</h2>
            <p>
            En tant qu’utilisateur du Site et des Service VEHIDOC, la société MFLJ est susceptible de collecter des données vous concernant comme détaillées ci-après.
            Lorsque vous renseignez directement les données, leur caractère obligatoire ou facultatif vous est signalé lors de la collecte (par une astérisque ou autre moyen équivalent).

            </p>
            <h3>1.1. Formulaire de contact sur le Site</h3>
            <p>Lors de l’utilisation du formulaire de contact, nous collectons les informations suivantes concernant le demandeur :</p>
            <ul>
              <li><strong>Données d’identification et de contact :</strong> prénom, nom, e-mail, téléphone</li>
              <li><strong>Données professionnelles :</strong> fonction</li>
              <li><strong>Données relatives à la société :</strong> société, SIRET, code postal, ville, marque</li>
            </ul>
            <h3>1.2. Relation client</h3>
            <p>Dans le cadre de la relation commerciale (y compris pré-contractuelle) entre MFLJ et son client, les données personnelles suivantes sont collectées concernant les interlocuteurs et représentants du client :</p>
            <ul>
              <li><strong>Données d’identification et de contact :</strong> prénom, nom, e-mail, téléphone</li>
              <li><strong>Données professionnelles :</strong> fonction</li>
            </ul>
            <h3>1.3. Données collectées via des cookies et traceurs</h3>
            <p>
                Nous collectons via des cookies et autres traceurs des données d’utilisation lorsque vous accédez à   notre Site et/ou que vous utilisez les Services liés. Nous sommes notamment susceptibles de collecter des données techniques sur votre connexion internet, votre navigateur et vos appareils.
                Pour en savoir plus, nous vous invitons à consulter notre politique relatives aux cookies utilisés sur
                notre Site, accessible ci-dessous, et les politiques dédiées.
            </p>
          </section>

          {/* Section 2: Utilisation des données */}
          <section className="privacy-policy-section">
            <h2>2. Utilisation de vos données</h2>
            <p>Nous utilisons les données collectées pour les finalités décrites dans la présente section. Les données ne sont en aucun cas vendues à des sociétés tierces par MFLJ.</p>
            <h3>2.1. Utilisation de vos données sur la base de l’exécution du contrat</h3>
            <p>Sur la base de l’exécution du contrat qui nous lie, nous utilisons vos données pour vous fournir nos
                services, et notamment à des fins de :
            </p>
            <ul>
            <li>Gestion de la relation client (gestion commerciale, facturation/recouvrement, archivage pour
                preuve, amélioration de la qualité des services, etc.)
            </li>
            <li>Gestion des questions/demandes au support client ou technique ;</li>
            <li>Communication sur les évolutions des Services.</li>
            </ul>
            <h3>2.2. Utilisation de vos données sur la base notre intérêt légitime</h3>
            <p>Sur la base de notre intérêt légitime, nous utilisons vos données à des fins de :</p>
            <ul>
            <li>Prospection commerciale, notamment par email et téléphone, pour vous faire parvenir nos
                    offres et informations. Vous pouvez vous opposer à tout moment à la réception de ces
                    communications ;
            </li>
            <li>Réalisation de statistiques et analyses marketing, afin de comprendre comment vous utilisez
                nos services ;
            </li>
            <li>Réalisation des enquêtes (ex. satisfaction, opinion...). Vous êtes libre de participer et pouvez
                vous opposer selon les modalités fournies au moment de l&apos;enquête ;
            </li>
            <li>Prévention et détection d&apos;éventuelles menaces contre la sécurité de notre site et des Services liés, de la fraude ou de toute autre activité illicite ;
            </li>
            <li>De preuve et de défense de nos intérêts.</li>
            </ul>
            <h3>2.3 Utilisation de vos données pour respecter nos obligations légales</h3>
            <p>
            Enfin, nous sommes susceptibles de traiter vos données dans le cadre du respect de nos obligations légales, et notamment de respect de la réglementation applicable aux sociétés commerciales (Notamment obligations légales de conservation des documents commerciaux et obligations  comptables/fiscales).
            </p>
          </section>

          {/* Section 3: Responsable de traitement */}
          <section className="privacy-policy-section">
            <h2>3. Responsable de traitement</h2>
            <p>
            MFLJ, société éditrice du Site <strong>vehidoc.fr</strong>, ayant son siège social au 12 C rue de la Vigne -35370- ETRELLES (RCS RENNES 824 278 196), représentée par Madame Morgane CHARPENTIER, en sa qualité de Gérante, est responsable du traitement des données qu’elle collecte dans le cadre de votre utilisation du Service VEHIDOC.
            </p>
          </section>

          {/* Section 4: Destinataires des données */}
          <section className="privacy-policy-section">
            <h2>4. Destinataires des données</h2>
            <p>
                Les données que nous collectons sont accessibles à nos prestataires de services, agissant en qualité de sous-traitants, qui concourent administrativement et techniquement à la réalisation des finalités visées ci-dessus (prestataire d’hébergement, etc.).
                Afin de respecter nos obligations légales, vos données personnelles peuvent également être transmises aux autorités administratives et judiciaires autorisées.
            </p>
          </section>

          {/* Section 5: Durée de conservation */}
          <section className="privacy-policy-section">
            <h2>5. Durée de conservation</h2>
            <p>
              Les données personnelles sont conservées pendant 5 ans à compter de la fin de la relation contractuelle pour les clients, ou 3 ans à compter du dernier contact pour les prospects.
            </p>
          </section>

          {/* Section 6: Vos droits */}
          <section className="privacy-policy-section">
            <h2>6. Vos droits</h2>
            <h3>6.1 Quels sont vos droits ?</h3>
            <ul>
                <li><strong>Droit d&apos;accès :</strong> il s’agit de votre droit d’obtenir la confirmation que vos données sont traitées ou non, et
                    si oui, d’accéder à ces données.
                </li>
                <li><strong>Droit de rectification :</strong> il s’agit de votre droit d’obtenir, dans les meilleurs délais, que vos données inexactes soient rectifiées, et que vos données incomplètes soient complétées.
                </li>
                <li><strong>Droit de suppression/Effacement :</strong> il s’agit de votre droit d’obtenir, dans les meilleurs délais, l’effacement de vos données, sans préjudice des obligations ou nécessité par ailleurs de conservation.
                </li>
                <li><strong>Droit de limitation :</strong> il s’agit de votre droit d’obtenir la limitation du traitement lorsque vous vous y opposez, lorsque vous contestez l’exactitude de vos données, lorsque vous pensez que leur traitement est illicite, ou lorsque vous en avez besoin pour la constatation, l’exercice ou la défense de vos droits en justice.
                </li>
                <li><strong>Droit d&apos;opposition :</strong> il s’agit de votre droit de vous opposer à tout moment au traitement de vos données par SNEEP, sauf en cas de motifs légitimes et impérieux de SNEEP. Vous pouvez également vous opposer au traitement fait à des fins de prospection le cas échéant.
                </li>
                <li><strong>Droit à la portabilité :</strong>il s’agit de votre droit de recevoir vos données dans un format structuré, couramment utilisé, lisible par machine et interopérable, et de les transmettre à un autre responsable du traitement sans que nous y fassions obstacle.
                </li>
                <li><strong>Droit de ne pas faire l&apos;objet d&apos;une décision fondée sur un traitement automatisé :</strong> vous avez le droit de ne pas faire l&apos;objet d&apos;une décision fondée exclusivement sur un traitement automatisé produisant des effets juridiques vous concernant ou vous affectant, sauf lorsque cette décision est nécessaire à la conclusion ou à l&apos;exécution d’un contrat, ou est autorisée légalement.
                </li>
            </ul>
            <p>Enfin, vous avez le droit d&apos;introduire une réclamation auprès d&apos;une autorité de contrôle et de donner des directives pour le sort de vos données personnelles en cas de décès.</p>
            <h3>6.2 Comment exercer vos droits ?</h3>
            <p>Vous pouvez à tout moment exercer les droits susvisés et nous poser tout question concernant la présente politique en nous contactant aux coordonnées précisées dans la section “Délégué à la protection des données” tout en bas du présent document.</p>
          </section>

          {/* Section 7: Sécurité des données */}
          <section className="privacy-policy-section">
            <h2>7. Sécurité de vos données</h2>
            <p>
            Nous et nos sous-traitants avons mis en place toutes les mesures techniques et organisationnelles pour préserver la confidentialité et la sécurité des données personnelles traitées, au regard de leur nature et des risques du traitement, et empêcher qu’elles ne soient déformées, endommagées, détruites ou que des tiers non autorisés y aient accès.
            </p>
          </section>
          <section className="privacy-policy-section">
            <h1>POLITIQUE RELATIVE AUX COOKIES ET AUTRES TRACEURS</h1>
            <p>
                MFLJ, souhaite vous informer de manière claire et transparente sur l&apos;usage des cookies lors de votre navigation sur notre Site.
                Pour toute question concernant la présente politique, vous pouvez nous contacter aux coordonnées précisées dans la section “Délégué à la protection des données” tout en bas du présent document.
            </p>
            <h2>1. Qu&apos;est-ce qu&apos;un cookie ?</h2>
            <p>
                Un cookie (ou autre traceur) est un fichier texte stocké sur le disque dur de votre terminal (ordinateur, tablette, mobile) par le biais de votre logiciel de navigation à l&apos;occasion de la consultation d&apos;un service en ligne (un site, une application mobile, etc.). Le mot &apos;cookies&apos; dans la présente politique désigne tous traceurs et autres technologies similaires pouvant être utilisés sur notre Site.
                Vous seul(e) choisissez si vous souhaitez avoir des cookies enregistrés sur votre appareil et vous pouvez facilement contrôler l&apos;enregistrement des cookies. Pour une information spécifique sur la gestion et le contrôle des cookies.
            </p>
            <h2>2. Les cookies utilisés par notre Site</h2>
            <p>
                Les cookies collectés sont uniquement des cookies fonctionnels nécessaires au fonctionnement du service.
                Leur utilisation ne repose que sur l’intérêt légitime de VEHIDOC.
                Ces cookies étant indispensables au bon fonctionnement de la plateforme VEHIDOC, le consentement de l’Utilisateur n’est pas requis.  
                Toutefois, l’Utilisateur peut configurer son navigateur pour bloquer ces cookies, sachant que cela pourrait altérer certaines fonctionnalités du site (exemples : l’authentification et la gestion sécurisée des sessions utilisateurs, la gestion des données temporaires lors de l’utilisation de l’application (exemple : navigation entre les pages sans perte d’information)).
            </p>
            </section>
            <section className="privacy-policy-section">
                <h1>Délégué à la protection des données</h1>
                <p>Pour exercer vos droits ou pour toute question concernant la présente politique, nous vous invitons à contacter le délégué à la protection des données, Mme Morgane CHARPENTIER, gérante de la société MFLJ, société éditrice du Site vehidoc.fr. Elle est joignable :</p>
                <ul>
                    <li><strong>par email :</strong> contact@vehidoc.fr</li>
                    <li><strong>par voie postale :</strong> MFLJ, Déléguée à la protection des données, au 12 C rue de la Vigne -35370- ETRELLES </li>
                </ul>
                <p>Si nous considérons nécessaire de confirmer votre identité, nous pourrons vous demander un justificatif d’identité.</p>
            </section>
        </main>
      </PageWrapper>

      {/* Footer */}
      <Footer />
    </div>
  );
};

PrivacyPolicy.propTypes = {
  menuState: PropTypes.shape({
    isMenuOpen: PropTypes.bool.isRequired,
    setIsMenuOpen: PropTypes.func.isRequired,
    onMenuToggle: PropTypes.func.isRequired,
  }).isRequired,
};

export default PrivacyPolicy;